export default "__VITE_ASSET__14f49ffa__"